module.exports = {"amp":"&","apos":"'","gt":">","lt":"<","quot":"\""}


//////////////////
// WEBPACK FOOTER
// ./node_modules/dom-serializer/node_modules/entities/lib/maps/xml.json
// module id = e+WT
// module chunks = 1 2 3 4